const RegisterSuccess = () => {
    return (
      <div style={styles.page}>
        <div style={styles.card}>
          <div style={styles.iconWrap}>
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#16a34a"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M20 6 9 17l-5-5" />
            </svg>
          </div>
  
          <h1 style={styles.title}>You're registered</h1>
  
          <p style={styles.text}>
            Thanks for signing up. Your account has been created successfully and
            is now under review by our team.
          </p>
  
          <div style={styles.notice}>
            <span style={styles.dot} />
            Account under review
          </div>
  
          <p style={styles.subtext}>
            We'll email you as soon as your account is approved. This usually takes
            1–2 business days.
          </p>
          
        </div>
      </div>
    );
  };
  
  const styles = {
    page: {
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#f8fafc",
      padding: "24px",
      fontFamily: "system-ui, -apple-system, sans-serif",
    },
    card: {
      width: "100%",
      maxWidth: "420px",
      background: "#fff",
      borderRadius: "16px",
      padding: "40px 32px",
      boxShadow: "0 8px 30px rgba(0,0,0,0.06)",
      textAlign: "center",
      border: "1px solid #eef2f7",
    },
    iconWrap: {
      width: "64px",
      height: "64px",
      borderRadius: "50%",
      background: "#dcfce7",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 auto 24px",
    },
    title: {
      fontSize: "24px",
      fontWeight: 700,
      color: "#0f172a",
      margin: "0 0 12px",
    },
    text: {
      fontSize: "15px",
      lineHeight: 1.6,
      color: "#475569",
      margin: "0 0 24px",
    },
    notice: {
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      background: "#fef9c3",
      color: "#854d0e",
      fontSize: "14px",
      fontWeight: 600,
      padding: "8px 16px",
      borderRadius: "999px",
      marginBottom: "20px",
    },
    dot: {
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      background: "#eab308",
    },
    subtext: {
      fontSize: "13px",
      lineHeight: 1.6,
      color: "#94a3b8",
      margin: "0 0 28px",
    },
    button: {
      display: "inline-block",
      background: "#0f172a",
      color: "#fff",
      fontSize: "15px",
      fontWeight: 600,
      padding: "12px 28px",
      borderRadius: "10px",
      textDecoration: "none",
    },
  };
  
  export default RegisterSuccess;